module.exports = __webpack_public_path__ + "img/About- FIRST pic.b686b5ad.jpg";